// Debug ads in the browser console

// Function to debug ads state
window.debugAds = function () {
    // console.log('=== Ad System Debug ===');

    // Check if store exists
    if (!window.store) {
        console.error('Vuex store not found');
        return;
    }

    // Check ads store state
    const adsState = window.store.state.ads;
    // console.log('Ads Store State:', adsState);
    // console.log('Total ads:', adsState.ads.length);
    // console.log('Gallery ads:', adsState.ads.filter((ad) => ad.location === 'gallery').length);
    // console.log('All ads:', adsState.ads);

    // Check each ad's ID
    adsState.ads.forEach((ad) => {
        // console.log(`Ad for ${ad.location}:`, {
        //     id: ad.id,
        //     html: ad.html ? ad.html.substring(0, 100) + '...' : 'no html',
        //     callback: ad.callback ? 'has callback' : 'no callback',
        //     rendered: ad.rendered
        // });
    });

    // Check AdService state
    if (window.Vue && window.Vue.prototype.$adService) {
        const adService = window.Vue.prototype.$adService;
        // console.log('AdService slots:', Object.keys(adService.slots));
        // console.log('AdService renderedAds:', adService.renderedAds);

        // Check each slot
        Object.keys(adService.slots).forEach((id) => {
            const slot = adService.slots[id];
            // console.log(`Slot ${id}:`, {
            //     loaded: slot.loaded,
            //     location: slot.location,
            //     canBeLoaded: slot.canBeLoaded ? slot.canBeLoaded() : 'N/A',
            //     hasElement: !!slot.element,
            //     inDOM: slot.element ? document.body.contains(slot.element) : false
            // });
        });
    }

    // Check window.searchLocation
    // console.log('window.searchLocation:', window.searchLocation);

    // console.log('=== End Debug ===');
};

// Auto-run debug on page load
window.addEventListener('load', () => {
    setTimeout(() => {
        // console.log('Auto-running ads debug...');
        window.debugAds();
    }, 3000);
});

// Watch for store mutations to debug when ads are added
setTimeout(() => {
    if (window.store) {
        // console.log('Setting up store watcher for ads debug');
        window.store.subscribe((mutation) => {
            if (mutation.type === 'ads/ADD_AD' || mutation.type === 'ads/ADD_MULTIPLE_ADS') {
                setTimeout(() => {
                    // console.log('Ads added to store, running debug...');
                    window.debugAds();
                }, 100);
            }
        });
    } else {
        // console.log('Store not available yet for watcher setup');
    }
}, 2000);
